import { render, staticRenderFns } from "./SmallBookmark.vue?vue&type=template&id=5f3cc7ee&"
import script from "./SmallBookmark.vue?vue&type=script&lang=ts&"
export * from "./SmallBookmark.vue?vue&type=script&lang=ts&"
import style0 from "./SmallBookmark.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports